export default __webpack_public_path__ + "0d7291e8bd3aa25178b9095d52cfaa9b.png";